import React from "react";

import styled from "styled-components";

import Layer from "components/atoms/Layer";
import StyledText from "components/atoms/text/StyledText";

const Wrapper = styled.div`
    padding: 8px 12px;
`;

const TitleText = styled(StyledText)`
    width: 100%;
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 4px;
`;

const ContentText = styled(StyledText)`
    width: 100%;
    font-size: 1.2rem;
    margin-bottom: 4px;
`;

function ReferenceLayer(props) {
    const { reference } = props;
    return (
        <Layer targetContent={props.children} {...props}>
            <Wrapper>
                <TitleText>{reference?.title}</TitleText>
                <ContentText>{reference?.author}</ContentText>
                <ContentText>
                    {reference?.publisher} ({reference?.year})
                </ContentText>
            </Wrapper>
        </Layer>
    );
}

export default ReferenceLayer;
